import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarkRequestReadState, ReadState, RequestReadState } from '@atlassian/notification-common/types';
export default function markBulkNotifications(currentNotifications, notificationsToMark, toState, readStateFilter) {
  var currentNotificationsMap = currentNotifications.reduce(function (indexes, notif) {
    indexes.set(notif.id, notif);
    return indexes;
  }, new Map());
  var notificationsToMarkMap = notificationsToMark.reduce(function (indexes, notif) {
    indexes.set(notif.id, notif);
    return indexes;
  }, new Map());
  var updatedList = currentNotifications.map(function (currentNotification) {
    if (notificationsToMarkMap.has(currentNotification.id)) {
      return _objectSpread(_objectSpread({}, currentNotification), {}, {
        readState: requestReadStateToRender(toState)
      });
    }
    return currentNotification;
  });
  if (readStateFilter === RequestReadState.UNREAD && toState === MarkRequestReadState.UNREAD) {
    var notificationsToAdd = notificationsToMark.filter(function (notificationToMark) {
      var exists = !!currentNotificationsMap.get(notificationToMark.id);
      return !exists;
    }).map(function (currentNotification) {
      return _objectSpread(_objectSpread({}, currentNotification), {}, {
        readState: requestReadStateToRender(toState)
      });
    });
    updatedList = updatedList.concat(notificationsToAdd).sort(function (a, b) {
      return a.timestamp < b.timestamp ? 1 : -1;
    });
  }
  return updatedList;
}
export var requestReadStateToRender = function requestReadStateToRender(requestReadState) {
  if (requestReadState === MarkRequestReadState.READ) {
    return ReadState.READ;
  }
  return ReadState.UNREAD;
};